import { memo, useCallback } from "react";
import closeIcon from "@source/assets/imgs/close.svg";
import styles from "./chip.module.scss";
import Svg from "@source/components/UI/svg/svg";

export default memo((props: ChipProps) => {
  const {onDelete, text, id, className} = props;

  const onCloseClick = useCallback(() => {
    onDelete && onDelete(id)
  }, [onDelete, id])

  return (
    <div className={`${styles.chip} ${className}`}>
      <div className={styles.text}>{text}</div>

      <div onClick={onCloseClick} className={styles.close}>
        <Svg className={styles.icon} src={closeIcon} width={12} height={12}/>
      </div>
    </div>
  )
})

interface ChipProps {
  /** chip text */
  text: string,

  /** chip id */
  id: string,

  /** cross click handler */
  onDelete?: (id: string) => void,

  /** className for container wrapping Chip component */
  className?: string
}